import { atom, selector, selectorFamily } from 'recoil'

export const safeAreaInsetState = atom({
    key: "safeAreaInsetState",
    default: {
        top: undefined,
        bottom: undefined,
        left: undefined,
        right: undefined
    }
})

export const userState = atom({
    key: "userState",
    default: undefined
})

export const systemState = atom({
	key: "systemState",
	default: {}
})

export const systemWebviewSelector = selector({
	key: "systemSelector",
	get: ({ get }) => {
		const system = get(systemState)
		return system.webview
	}
})

export const fromState = atom({
    key: "fromState",
    default: undefined
})

export const popupState = atom({
    key: "popupState",
    default: false
})

// global check my data link - false일 경우 마데 연동중으로 체크 / true면 global bottom으로 알럿 후 닫히면 undefined로 초기화
export const checkMyDataLinkState = atom({
    key: "checkMyDataLinkState",
    default: undefined
})
// my data link result url state
export const myDataLinkResultUrlState = atom({
    key: "myDataLinkResultUrlState",
    default: undefined
})
// my data 연동 중 화면 진입, 또는 API 호출을 막았을 때 노출되는 bottom layer state
export const myDataLinkBottomLayerState = atom({
    key: "myDataLinkBottomLayerState",
    default: false
})

// SlideBanner의 realEstate 배너 노출 여부
export const showRealEstateBannerState = atom({
    key: "showRealEstateBannerState",
    default: false
})